<app-request-an-insurance-quote mainHeading="REQUEST AN INSURANCE QUOTE"
    [subHeading]="this.dataService.leadDetails.isServiceUnavailable?'false':'true'"></app-request-an-insurance-quote>
<form (ngSubmit)="onSubmit(custForm)" autocomplete="off" #custForm="ngForm"
    (keydown.enter)="$event.preventDefault();onSubmit(custForm)">
    <section id="ServiceUnavailable" class="pb-5" *ngIf="this.dataService.leadDetails.isServiceUnavailable">
        <div class="container">
            <div class="row justify-content-center col-md-12">
                <!-- <div class="col-md-3"></div> -->
                <div class="col-md-7 col-xs-12">
                    <span id="messageError" class="text-uppercase service-error-message"
                        [innerHTML]="dataService.leadDetails.errorMessage"></span>
                </div>
                <!-- <div class="col-md-3"></div> -->
            </div>
        </div>
    </section>
    <img src="assets/img/PRELOADER.gif" class="preloader" *ngIf="isLoading" />
    <!-- A D D R E S S -->
    <section id="rtq-form" class="pb-5">
        <div class="container" [hidden]="this.dataService.leadDetails.isServiceUnavailable">
            <div class="row justify-content-center">
                <div class="col-md-7 col-xs-12">
                    <span class="pl-3">Property Address</span>
                    <br>
                    <br>
                    <div>
                        <div class="form-div">
                            <div class="row pt-3">
                                <div class="col">
                                    <label for="addressLine1">Address Line 1</label>
                                    <input type="search" #propStreetAddress name="streetAddress" id="address-line-one"
                                        placeholder="&nbsp; &nbsp; Property Address"
                                        class="form-control search-icon address address-line-one"
                                        appGoogleAutoCompletePlaces
                                        (onselect)="SetPropertyAddressDetails($event);populateMailingAddress();"
                                        (ngModelChange)="populateMailingAddress()"
                                        [(ngModel)]="custDetails.customerAddress.streetAddress" maxlength="36"
                                        autocomplete="search">
                                    <i class="far fa-search address-line-search-icon" aria-hidden="true"
                                        id="address-line-search-one"></i>
                                </div>
                            </div>
                            <div class="row pt-3">
                                <div class="col">
                                    <label for="Address2">Address Line 2</label>
                                    <input type="email" class="form-control address" id="txtPropertyLine2"
                                        aria-describedby="emailHelp" name="Line" #line2 placeholder="Line 2"
                                        [(ngModel)]="custDetails.customerAddress.line2" maxlength="36"
                                        (ngModelChange)="populateMailingAddress()">
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col-lg-4 col-xs-12 col-sm-12">
                                    <label for="City">City <span>*</span></label>
                                    <input type="text" class="form-control" id="txtCity" placeholder="City" required
                                        #cities [(ngModel)]="custDetails.customerAddress.city" name="City"
                                        #city="ngModel" maxlength="23" (ngModelChange)="populateMailingAddress()">
                                    <label *ngIf="(city.hasError('required') && city.touched)"
                                        class="error-message">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                                <div class="col-lg-4 mob-pt-3 col-xs-12 col-sm-12">
                                    <label for="state">State <span>*</span></label>
                                    <select class="form-control state-width" id="txtState" name="State"
                                        (ngModelChange)="populateMailingAddress()" required
                                        [(ngModel)]="custDetails.customerAddress.state" #state="ngModel" #states>
                                        <option selected value=""></option>
                                        <option *ngFor="let item of lstStates" [value]="item.stateName">
                                            {{item.stateName}}</option>
                                    </select>
                                    <label *ngIf="(state.hasError('required') && state.touched) "
                                        class="error-message">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                                <div class="col-lg-4 mob-pt-3 col-xs-12 col-sm-12">
                                    <label for="ZipCode">Postal Code <span>*</span></label>
                                    <input type="text" class="form-control zip-width" id="txtZip" placeholder="Zip"
                                        name="Zipcode" minlength="5" maxlength="10" required #ZipCodes
                                        [(ngModel)]="custDetails.customerAddress.zipCode"
                                        (ngModelChange)="populateMailingAddress()" #ZipCode="ngModel"
                                        ZipcodeValidator />
                                    <label *ngIf="(ZipCode.hasError('required') && ZipCode.touched) "
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(custDetails.customerAddress!=undefined && custDetails.customerAddress.zipCode!='' && ZipCode.invalid && ZipCode.touched)"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                </div>
                            </div>

                            <div class="row pt-4">
                                <div class="col-lg-8 col-xs-12 col-sm-12">
                                    <label for="County">County</label>
                                    <input type="text" #propCounty class="form-control address" id="txtPropertyCounty"
                                        #propCountys placeholder="County" maxlength="19"
                                        [(ngModel)]="custDetails.customerAddress.county" name="County">
                                </div>
                            </div>
                            <div class="row pt-4" *ngIf="true">
                                <div class="col">
                                    <label for="policynumber">Please select one <span>*</span></label>
                                    <div class="col">
                                        <div class="form-check form-check-inline pb-2 row w-100">
                                            <button type="button" [(ngModel)]="custDetails.loanType"
                                                [value]="loanType.Owner"
                                                (click)="this.commonService.FormatRadioButton($event,loanType.Owner);loanTypeUpdateValidation(loanType.Owner);"
                                                #LoanType="ngModel" name="subject" ngDefaultControl required
                                                [ngClass]="{'active': custDetails.loanType==loanType.Owner}" #loantype1
                                                class="radio-btn btn btn-outline-dark">I am the current owner
                                                of this property</button>

                                        </div>
                                        <div class="form-check form-check-inline pb-2 row w-100">
                                            <button type="button" [(ngModel)]="custDetails.loanType"
                                                [value]="loanType.Purchase"
                                                (click)="this.commonService.FormatRadioButton($event,loanType.Purchase);loanTypeUpdateValidation(loanType.Purchase);"
                                                #LoanType="ngModel" name="subject" ngDefaultControl required
                                                [ngClass]="{'active': custDetails.loanType==loanType.Purchase}"
                                                class="radio-btn btn btn-outline-dark">I am planning to
                                                purchase this property</button>

                                        </div>
                                        <div class="form-check form-check-inline pb-2 row w-100">
                                            <button type="button" [(ngModel)]="custDetails.loanType"
                                                [value]="loanType.None"
                                                (click)="this.commonService.FormatRadioButton($event,loanType.None);loanTypeUpdateValidation(loanType.None);"
                                                #LoanType="ngModel" name="subject" ngDefaultControl required
                                                [ngClass]="{'active': custDetails.loanType==loanType.None}"
                                                class="radio-btn btn btn-outline-dark">I am planning to rent
                                                this property from someone else</button>

                                        </div>
                                    </div>
                                    <label *ngIf="LoanType.hasError('required') && LoanType.touched"
                                        class="error-message text-nowrap">{{constantsObj.selectOneErrorMessage}}</label>
                                </div>
                            </div>
                            <div class="row pt-4"
                                [hidden]="custDetails.loanType==loanType.Owner || custDetails.loanType==''">
                                <label for="lblEstCloseDate"
                                    class="required col-form-label col-md-5 pr-0 col-form-label-sm text-sm-right">
                                    {{custDetails.loanType==loanType.Purchase?"What is your estimated close
                                    date?":(custDetails.loanType==loanType.None?"What date would you like this quote to
                                    be
                                    effective?":"")}} <span>*</span>
                                </label>
                                <div class="col-md-7">
                                    <input type="text" #EstCloseDateDP class="form-control" id="txtEstCloseDate"
                                        placeholder="MM/DD/YYYY" [minDate]="maxDate" name="EstCloseDate"
                                        [(ngModel)]="custDetails.estCloseDate" bsDatepicker #dp1="bsDatepicker"
                                        [outsideClick]="true" [isOpen]="isOpen" (keydown.Tab)="hideDatePicker(dp1)"
                                        (onHidden)="handler('EstCloseDateDP')" #EstCloseDate="ngModel"
                                        [required]="custDetails.loanType==loanType.Purchase || custDetails.loanType==loanType.None"
                                        [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                        dateValidatorForEstCloseDate />
                                    <label
                                        *ngIf="(EstCloseDate.hasError('required') && (EstCloseDate.touched || custForm.submitted))"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(EstCloseDate.hasError('dateValidatorForEstCloseDate') && (EstCloseDate.touched || custForm.submitted))"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                    <label
                                        *ngIf="(EstCloseDate.hasError('pastDateValidatorForEstCloseDate') && EstCloseDate.touched)"
                                        class="error-message text-nowrap">{{constantsObj.invalidPastDate}}</label>
                                </div>
                            </div>


                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>

    <!-- // A D D R E S S -->


    <!-- C U S T O M E R   I N F O  -->

    <section id="rtq-form" class="pb-5">
        <div class="container" [hidden]="this.dataService.leadDetails.isServiceUnavailable">
            <div class="row justify-content-center">
                <div class="col-md-7 col-xs-12">
                    <span class="pl-3">Customer information</span>
                    <br>
                    <br>
                    <div>
                        <div class="form-div">
                            <div class="row pt-3">
                                <div class="col-lg-6 col-xs-12 col-sm-12">
                                    <label for="FirstName">Customer First Name <span>*</span></label>
                                    <input type="text" class="form-control" id="txtFirstName" placeholder="First Name"
                                        maxlength="17" required [(ngModel)]="custDetails.firstName" name="FirstName"
                                        #firstName="ngModel" #firstNameDP />
                                    <label *ngIf="(firstName.hasError('required') && firstName.touched)"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                                <div class="col-lg-6 col-xs-12 col-sm-12">
                                    <label for="LastName">Customer Last Name <span>*</span></label>
                                    <input type="text" class="form-control" id="txtLastName" placeholder="Last Name"
                                        maxlength="20" required [(ngModel)]="custDetails.lastName" name="LastName"
                                        #lastName="ngModel">
                                    <label *ngIf="(lastName.hasError('required') && lastName.touched)"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col-lg-6 col-xs-12 col-sm-12">
                                    <label for="phone">Preferred Phone <span>*</span></label>
                                    <input type="text" class="form-control phoneValue-width" id="txtPreferredPhone"
                                        placeholder="(999) 999-9999" minlength="10" mask="(000) 000-0000" required
                                        [(ngModel)]="custDetails.homePhone" name="preferredPhone"
                                        #preferredPhone="ngModel">
                                    <label
                                        *ngIf="(preferredPhone.hasError('required') && preferredPhone.touched) &&((phoneTypes.hasError('required') && phoneTypes.touched)|| ((custDetails.homePhoneType=='' || custDetails.homePhoneType=='0') && phoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(preferredPhone.hasError('required') && preferredPhone.touched) &&!((phoneTypes.hasError('required') && phoneTypes.touched)|| ((custDetails.homePhoneType=='' || custDetails.homePhoneType=='0') && phoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(preferredPhone.hasError('minlength') && preferredPhone.touched) &&((phoneTypes.hasError('required') && phoneTypes.touched)|| ((custDetails.homePhoneType=='' || custDetails.homePhoneType=='0') && phoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                    <label
                                        *ngIf="(preferredPhone.hasError('minlength') && preferredPhone.touched) && !((phoneTypes.hasError('required') && phoneTypes.touched)|| ((custDetails.homePhoneType=='' || custDetails.homePhoneType=='0') && phoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                </div>

                                <div class="col-lg-6  mob-pt-3 col-xs-12 col-sm-12">
                                    <label for="PhoneType">Phone Type <span>*</span></label>
                                    <select class="form-control phoneType-width" id="txtPhoneTypes" name="phoneTypes"
                                        [ngModelOptions]="{ updateOn: 'blur' }" [(ngModel)]="custDetails.homePhoneType"
                                        required #phoneTypes="ngModel" validatePhoneTypes>
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of lstPhoneTypes" [value]="item.phoneValue">
                                            {{item.phoneType}}</option>
                                    </select>

                                    <label
                                        *ngIf="phoneTypes.hasError('required') && phoneTypes.touched || 
                                    ((custDetails.homePhoneType=='' || custDetails.homePhoneType=='0' || custDetails.homePhoneType==null) && phoneTypes.touched)"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col-lg-6 col-xs-12 col-sm-12">
                                    <label for="phone">Alternate Phone</label>
                                    <input type="text" autocomplete="off" class="form-control phoneValue-width"
                                        id="txtAlternatePhone" placeholder="(999) 999-9999" minlength="10"
                                        mask="(000) 000-0000" autocomplete="off"
                                        [required]="!(custDetails.alternatePhoneType=='' || custDetails.alternatePhoneType=='0' || custDetails.alternatePhoneType==null)"
                                        [(ngModel)]="custDetails.alternatePhone" name="alternatePhone"
                                        #alternatePhone="ngModel">
                                    <label
                                        *ngIf="(alternatePhone.hasError('required') && alternatePhone.touched) 
                                        &&((!(custDetails.alternatePhoneType=='' || custDetails.alternatePhoneType=='0' || custDetails.alternatePhoneType==null) && altPhoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(alternatePhone.hasError('minlength') && alternatePhone.touched) &&((altPhoneTypes.touched)|| ((custDetails.alternatePhoneType=='' || custDetails.alternatePhoneType=='0' || custDetails.alternatePhoneType==null) && altPhoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                    <label
                                        *ngIf="(alternatePhone.hasError('minlength') && alternatePhone.touched) && !(( altPhoneTypes.touched)|| ((custDetails.alternatePhoneType=='' || custDetails.alternatePhoneType=='0' || custDetails.alternatePhoneType==null) && altPhoneTypes.touched))"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                </div>

                                <div class="col-lg-6 mob-pt-3 col-xs-12 col-sm-12">
                                    <label for="PhoneType">Phone Type</label>
                                    <select class="form-control phoneType-width" id="txtaltPhoneTypes"
                                        name="altPhoneTypes" [ngModelOptions]="{ updateOn: 'blur' }"
                                        [(ngModel)]="custDetails.alternatePhoneType" placeholder="PhoneType"
                                        #altPhoneTypes="ngModel" validatePhoneTypes
                                        [required]="!(custDetails.alternatePhone=='' || custDetails.alternatePhone == null)">
                                        <option selected [ngValue]="''"></option>
                                        <option *ngFor="let item of lstPhoneTypes" [value]="item.phoneValue">
                                            {{item.phoneType}}</option>
                                    </select>
                                    <label *ngIf="altPhoneTypes.hasError('required') && altPhoneTypes.touched"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label *ngIf="!(custDetails.homePhoneType=='' || custDetails.homePhoneType=='0' || custDetails.homePhoneType==null)&&
                                    (!(custDetails.alternatePhoneType=='' || custDetails.alternatePhoneType=='0' || custDetails.alternatePhone==null) && 
                                    altPhoneTypes.touched) && (phoneTypes.hasError('validatePhoneTypes') || altPhoneTypes.hasError('validatePhoneTypes') )
                                    && (phoneTypes.touched && altPhoneTypes.touched)"
                                        class="error-message">{{constantsObj.phoneTypesCannotMatchErrorMessages}}</label>
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col">
                                    <label for="Email">Email <span>*</span></label>
                                    <input type="email" class="form-control" id="txtEmail" placeholder="Email"
                                        [ngModelOptions]="{ updateOn: 'blur' }" required [(ngModel)]="custDetails.email"
                                        name="Email" #email="ngModel" emailValidator maxlength="100">
                                    <label *ngIf="(email.hasError('required') && email.touched)"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(email.hasError('emailValidator') && email.touched && !email.hasError('required'))"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col">
                                    <label class="control-label" for="date">Applicant DOB</label>
                                    <i
                                        class="fa fa-question-circle help-icon-custom text-sm-right help date-helper-icon"></i>
                                    <input type="text" #ApplicantDOBDP class="form-control" id="txtDOB"
                                        placeholder="MM/DD/YYYY" [maxDate]="maxDate" name="ApplicantDOB"
                                        [(ngModel)]="custDetails.applicantDOB" #dp2="bsDatepicker"
                                        #ApplicantDOB="ngModel" bsDatepicker [outsideClick]="true" [isOpen]="isOpen"
                                        (keydown.Tab)="hideDatePicker(dp2)" (onHidden)="handler('ApplicantDOBDP')"
                                        [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                        dateValidator />
                                    <label *ngIf="(ApplicantDOB.hasError('dateValidator') && ApplicantDOB.touched)"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                    <label *ngIf="(ApplicantDOB.hasError('maxDateValidator') && ApplicantDOB.touched)"
                                        class="error-message text-nowrap">{{constantsObj.invalidFutureDate}}</label>
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col-lg-6 col-xs-12 col-sm-12">
                                    <label for="FirstName">Co-Applicant First Name </label>
                                    <input type="text" class="form-control" id="txtCoFirstName"
                                        placeholder="Co-Applicant First Name" maxlength="17"
                                        [(ngModel)]="custDetails.coFirstName" name="CoFirstName" #coFirstName="ngModel">
                                </div>
                                <div class="col-lg-6 col-xs-12 col-sm-12">
                                    <label for="LastName">Co-Applicant Last Name</label>
                                    <input type="text" class="form-control" id="txtCoLastName"
                                        placeholder="Co-Applicant Last Name" maxlength="20"
                                        [(ngModel)]="custDetails.coLastName" name="CoLastName">
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col">
                                    <label class="control-label" for="date">Co-Applicant DOB</label>
                                    <input type="text" #coApplicantDOBDP class="form-control" id="txtCoDOB"
                                        placeholder="MM/DD/YYYY" [maxDate]="maxDate" name="CoApplicanrDOB"
                                        [(ngModel)]="custDetails.coApplicantDOB" #dp3="bsDatepicker" bsDatepicker
                                        #CoApplicantDOB="ngModel" [outsideClick]="true" [isOpen]="isOpen"
                                        (keydown.Tab)="hideDatePicker(dp3)" (onHidden)="handler('coApplicantDOBDP')"
                                        [bsConfig]="{ showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY' }"
                                        dateValidator />
                                    <label *ngIf="(CoApplicantDOB.hasError('dateValidator') && CoApplicantDOB.touched)"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                    <label
                                        *ngIf="(CoApplicantDOB.hasError('maxDateValidator') && CoApplicantDOB.touched)"
                                        class="error-message text-nowrap">
                                        {{constantsObj.invalidFutureDate}}
                                    </label>
                                </div>
                            </div>
                            <div class="row pt-3">
                                <div class="col">
                                    <label for="lblSameMaillingAddress">Please select one <span>*</span></label>
                                    <div class="col">
                                        <div class="form-check form-check-inline pb-2 row w-100">
                                            <button type="button" required
                                                [(ngModel)]="custDetails.isMailingAddressSame" value="true"
                                                (click)="this.commonService.FormatRadioButton($event,1);custDetails.isMailingAddressSame='Yes';mailingAddressSame=true;populateMailingAddress()"
                                                #IsMailingAddressSame="ngModel" name="radIsMailingAddressSame"
                                                ngDefaultControl
                                                [ngClass]="{'active': custDetails.isMailingAddressSame== 'Yes'}"
                                                class="radio-btn btn btn-outline-dark">
                                                Mailing Same as Property
                                            </button>

                                        </div>
                                        <div class="form-check form-check-inline pb-2 row w-100">
                                            <button type="button" required
                                                [(ngModel)]="custDetails.isMailingAddressSame" value="false"
                                                (click)="this.commonService.FormatRadioButton($event,0);custDetails.isMailingAddressSame='No';mailingAddressSame=false;populateMailingAddress();clearData();"
                                                #IsMailingAddressSame="ngModel" name="radIsMailingAddressSame"
                                                ngDefaultControl
                                                [ngClass]="{'active': custDetails.isMailingAddressSame== 'No'}"
                                                class="radio-btn btn btn-outline-dark">
                                                Enter Different Mailing Address
                                            </button>

                                        </div>

                                    </div>
                                    <label
                                        *ngIf="IsMailingAddressSame.hasError('required') && IsMailingAddressSame?.touched"
                                        class="error-message text-nowrap">
                                        {{constantsObj.selectOneErrorMessage}}
                                    </label>
                                </div>
                            </div>
                            <div class="row pt-3">
                                <div class="col">
                                    <label for="MailingAddress">Address Line 1 <span>*</span></label>
                                    <input type="search" autocomplete="search"
                                        class="form-control search-icon address address-line-one" id="address-line-two"
                                        placeholder="&nbsp; &nbsp; Mailing Address" [disabled]=mailingAddressSame
                                        required [(ngModel)]="custDetails.mailingAddress.streetAddress"
                                        (ngModelChange)="changingAddressLineOne()" name="MailingAddress"
                                        appGoogleAutoCompletePlaces (onselect)="SetMailingAddressDetails($event)"
                                        #mailingAddress="ngModel" #mailingStreet maxlength="36">
                                    <i class="far fa-search address-line-search-icon" aria-hidden="true"
                                        id="address-line-search-two"
                                        [ngClass]="  (mailingAddress.hasError('required') && mailingAddress.touched)  ? 'far fa-search address-line-search-icon-req' : 'far fa-search address-line-search-icon'"></i>
                                    <label
                                        *ngIf="(mailingAddress.hasError('required') && mailingAddress.touched) || (( mailingAddressSame && mailingAddress.untouched) && (custDetails.mailingAddress.streetAddress==null || custDetails.mailingAddress.streetAddress==''))"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col">
                                    <label for="Address2">Address Line 2</label>
                                    <input type="email" class="form-control"
                                        [(ngModel)]="custDetails.mailingAddress.line2" name="Line2" #mailingLine
                                        [disabled]=mailingAddressSame class="form-control address" id="txtMailingLine2"
                                        placeholder="Line 2" maxlength="36">
                                </div>
                            </div>

                            <div class="row pt-3">
                                <div class="col-lg-4 col-xs-12 col-sm-12">
                                    <label for="City">City <span>*</span></label>
                                    <input type="text" class="form-control city-width" id="txtMailingCity" #mailCity
                                        placeholder="City" [disabled]=mailingAddressSame required
                                        [(ngModel)]="custDetails.mailingAddress.city" name="MailingCity"
                                        #mailingCity="ngModel" maxlength="23">
                                    <label *ngIf="(mailingCity.hasError('required') && mailingCity.touched)"
                                        class="error-message">{{constantsObj.requiredErrorMessage}}</label>
                                </div>
                                <div class="col-lg-4 mob-pt-3 col-xs-12 col-sm-12">
                                    <label for="state">State <span>*</span></label>
                                    <select class="form-control state-width" id="txtMailingState" #mailState
                                        name="MailingState" required [disabled]=mailingAddressSame
                                        [(ngModel)]="custDetails.mailingAddress.state" #mailingState="ngModel">
                                        <option selected value=""></option>
                                        <option *ngFor="let item of lstStates" [value]="item.stateName">
                                            {{item.stateName}}</option>
                                    </select>
                                    <label *ngIf="(mailingState.hasError('required') && mailingState.touched) "
                                        class="error-message">{{constantsObj.requiredErrorMessage}}</label>
                                </div>

                                <div class="col-lg-4 mob-pt-3 col-xs-12 col-sm-12">
                                    <label for="ZipCode">Postal Code <span>*</span></label>
                                    <input type="text" class="form-control zip-width" id="txtMailingZip" #mailZipCode
                                        placeholder="Zip" name="mailingZipCode" [disabled]=mailingAddressSame
                                        minlength="5" maxlength="10" required
                                        [(ngModel)]="custDetails.mailingAddress.zipCode" #mailingZipCode="ngModel"
                                        ZipcodeValidator />
                                    <label *ngIf="(mailingZipCode.hasError('required') && mailingZipCode.touched)"
                                        class="error-message text-nowrap">{{constantsObj.requiredErrorMessage}}</label>
                                    <label
                                        *ngIf="(mailingZipCode.invalid && mailingZipCode.touched && custDetails.mailingAddress!=undefined && custDetails.mailingAddress.zipCode!='')"
                                        class="error-message text-nowrap">{{constantsObj.invalidFormatErrorMessage}}</label>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </section>

    <div class="container" *ngIf="!this.dataService.leadDetails.isServiceUnavailable">
        <div class="row">
            <p class="req-msg-note">*These fields are required</p>
        </div>
    </div>

    <section id="request-change-form" class="pb-5">
        <div class="container" [hidden]="this.dataService.leadDetails.isServiceUnavailable">
            <div class="row justify-content-center">
                <div class="col-md-7 col-xs-12">
                    <div>
                        <div class="row"
                            *ngIf="!custDetails.isEmailProspect && !this.dataService.leadDetails.isServiceUnavailable">
                            <div class="col pr-5 pb-2 text-right" *ngIf="!this.commonService.isSafariBroswer()">
                                <ngx-recaptcha2 [siteKey]="siteKey" [size]="size" [hl]="language"
                                    (success)="handleSuccess($event)" (load)="handleLoad()" (expire)="handleExpire()"
                                    [theme]="theme" [type]="type" [(ngModel)]="recaptcha"
                                    [ngModelOptions]="{ standalone: true }">
                                </ngx-recaptcha2>
                            </div>
                        </div>
                        <div class="row"
                            *ngIf="!custDetails.isEmailProspect && !this.dataService.leadDetails.isServiceUnavailable">
                            <div class="col pr-5 pb-2 text-right" *ngIf="false">
                                <ngx-invisible-recaptcha #captchaElem [siteKey]="siteKey" (ready)="handleReady()"
                                    (load)="handleLoad()" (success)="handleSuccess($event)" [type]="type"
                                    [badge]="badge" [ngModel]="recaptcha" [ngModelOptions]="{ standalone: true }">
                                </ngx-invisible-recaptcha>
                            </div>
                        </div>
                        <label *ngIf="(captchaRequired && custForm.submitted)"
                            class="error-message text-nowrap pl-2">{{constantsObj.requiredErrorMessage}}</label>
                        <div class="row pl-3" *ngIf="custDetails.isDuplicateLead">
                            <span id="messageError" class="font-weight-bold service-error-message"
                                [innerHTML]='custDetails.message'>
                            </span>
                        </div>
                        <!-- Button -->
                        <div class="row pt-3">

                            <div class="col" *ngIf="!custDetails.isPreviousBtnDisabled">
                                <button type="button" tabindex="-1"
                                    class="btn angled-button-sm button-width-110 button-align-mob-previous previous-left"
                                    (click)="GotoHomePage()" *ngIf="!custDetails.isPreviousBtnDisabled">
                                    <span>Previous</span>
                                </button>

                            </div>
                            <div class="col">
                                <button type="submit" class="btn angled-button-sm  btn-next-120 "
                                    [disabled]="(custDetails.isDuplicateLead && custDetails.message!='')"
                                    [ngClass]="custDetails.isPreviousBtnDisabled ? 'button-align-mob-center next-arrow':'button-align-mob-next'">
                                    <span>Next</span>
                                </button>
                            </div>

                        </div>
                        <div class="row pt-3" [hidden]="setContacteMeHidden()">
                            <button type="button" class="btn angled-button-sm button-width-190 button-align-mob-center"
                                (click)="this.popUp.openModal()">
                                <span>Please contact me</span>
                            </button>
                        </div>
                        <app-model-popup (savePageDetails)="savePageDetails()"></app-model-popup>
                        <!-- // Button -->

                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- // C U S T O M E R   I N F O -->

</form>